import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { routes } from 'appConstants';
import { EventsList, EventsDetails } from 'containers';

const Events = () => (
  <Switch>
    <Route
      path={routes.events.root}
      exact
      component={EventsList}
    />
    <Route
      path={`${routes.events.root}/:id`}
      exact
      component={EventsDetails}
    />
  </Switch>
);

export default Events;
